import React, { useState, useCallback } from 'react';
import { Card, CardContent, Typography, TextField, MenuItem } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { API_DOMAIN } from '../../../../constants';
import AlertCompanyDetail from '../../products/components/AlertCompanyDetail';
import homeStyles from '../../homeStyles';
import { ICompany } from '../../../../interfaces/companies';
import { thousands } from '../../../../utils/utils';
import { IOrder, IOrderItem } from '../../../../interfaces/order';
import { ButtonWithLoader } from '../../../../components/other/Buttons';
import { useOrderTableStyles } from '../hooks/useOrderTableStyles';
import CompanyInfo from './CompanyInfo';
import { Payment } from './Payment';
import { IUser } from '../../../../interfaces/user';

interface IProps {
  orders: IOrder | null;
  //   productEstimate: IProduct | null;
  isVendor: boolean | null;
  selectAction: (id: any) => void;
  selectedId: number;
  editStatus?: (id: any) => void;
  me?: IUser | null;
  isBuyer?: boolean;
}

const OrderTable: React.FC<IProps> = ({
  orders,
  isVendor,
  selectedId,
  selectAction,
  editStatus,
  me,
  isBuyer,
}) => {
  const { classes } = useOrderTableStyles();
  const homeClasses = homeStyles();
  const intl = useIntl();
  const [isOpenCompanyDialog, setOpenCompanyDialog] = useState(false);
  const [isOpenEstimateDialog, setOpenEstimateDialog] = useState(false);

  const [showPayment, setShowPayment] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState<{
    type: 'buyer' | 'seller';
    order: IOrder;
  }>({} as any);

  const [com, setCompany] = useState<ICompany>();

  const translates: { [type: string]: string } = {
    paid: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.PAID' }),
    not_paid: intl.formatMessage({ id: 'ORDER.PAYMENT.STATUS.NOT_PAID' }),
  };

  const orderTypeList: { type: string }[] = [{ type: 'paid' }, { type: 'not_paid' }];

  const openPayment = (type: 'buyer' | 'seller', order: IOrder) => {
    setPaymentInfo({ type, order });
    setShowPayment(true);
  };

  const openModalCompany = useCallback((company: ICompany) => {
    setCompany(company);
    setOpenCompanyDialog(true);
  }, []);

  const getPriceProduct = (item: IOrderItem) => {
    if (!isVendor) return item.product_price;
    return item.vendor_price || 0;
  };

  return (
    <>
      {orders &&
        orders.orders?.map(order => (
          <>
            {me?.is_admin && order.company && (
              <CompanyInfo
                compBrand={order.company.brand}
                compName={order.company.name}
                rightTitle='О продавце'
                onPress={() => openModalCompany(order.company)}
              />
            )}

            {order.items.map(item => {
              return (
                <Card key={item.id} className={classes.card}>
                  <CardContent className={classes.tableContainer}>
                    <div className={classes.contentWrapper}>
                      <div>
                        {item.product.photos && item.product.photos.length > 0 ? (
                          <img
                            alt=''
                            src={`${API_DOMAIN}/${
                              item?.product?.photos?.find((el: any) => el.main)?.small ||
                              item.product.photos[0].small
                            }`}
                            className={classes.img}
                          />
                        ) : (
                          <img
                            alt=''
                            src='../../../images/placeholder.png'
                            className={classes.img}
                          />
                        )}
                      </div>

                      <div className={classes.infoWrapper}>
                        <div className={classes.infoButtonsWrapper}>
                          <div className={classes.containerLink}>
                            <Link
                              to={`${
                                //   isAdmin
                                //     ? `/products/edit/${item.product.id}`
                                // :
                                `/viewproduct/${item.product.id}`
                              }`}
                              className={classes.link}
                            >
                              {item.product.name}
                            </Link>
                          </div>

                          <div style={{ width: 200 }}>
                            <Typography className={classes.productPrice}>
                              {thousands(String(getPriceProduct(item)))} руб.
                            </Typography>
                            <Typography className={classes.titlePriceOnce}>
                              Цена за 1 шт.
                            </Typography>
                          </div>

                          <div className={classes.containerCount}>
                            <Typography className={classes.count}>{item.count}</Typography>
                          </div>

                          <div className={classes.containerSum}>
                            <Typography className={classes.sum}>
                              {thousands(String(getPriceProduct(item) * item.count))} руб.
                            </Typography>
                            <Typography className={classes.titleSum}>Сумма</Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}

            {!isBuyer && (
              <Card className={classes.cardFooter}>
                <CardContent className={classes.containerSumVendor}>
                  <div className={classes.wrapperSumVendor}>
                    <Typography className={classes.titleVendorSum}>
                      ИТОГО ПО ПРОДАВЦУ:
                    </Typography>

                    <Typography className={classes.vendorSum}>
                      {thousands(String(isVendor ? order.vendor_summ || 0 : order.summ || 0))}{' '}
                      руб.
                    </Typography>
                  </div>

                  <Typography className={classes.paymentStatus}>
                    {translates[order.payment_status]}
                  </Typography>

                  <ButtonWithLoader
                    onPress={() =>
                      openPayment(isVendor || me?.is_admin ? 'seller' : 'buyer', order)
                    }
                  >
                    Реквизиты для оплаты
                  </ButtonWithLoader>
                </CardContent>
              </Card>
            )}
          </>
        ))}
      <>
        {me?.is_admin && orders?.items && orders?.items.length > 0 && (
          <CompanyInfo
            compBrand={orders?.company?.brand}
            compName={orders?.company?.name}
            rightTitle='О продавце'
            onPress={() => {
              const company = orders?.company;
              if (company) {
                openModalCompany(company);
              }
            }}
          />
        )}

        {orders &&
          orders?.items?.map(order => {
            // const totalOrderPrice = totalPriceByOrder(orders.items);
            return (
              <Card className={classes.card}>
                <CardContent className={homeClasses.classes.tableContainer}>
                  <div className={classes.contentWrapper}>
                    <div>
                      {order.product.photos && order.product.photos.length > 0 ? (
                        <img
                          alt=''
                          src={`${API_DOMAIN}/${
                            order?.product?.photos?.find((el: any) => el.main)?.small ||
                            order.product.photos[0].small
                          }`}
                          className={classes.img}
                        />
                      ) : (
                        <img
                          alt=''
                          src='../../../images/placeholder.png'
                          className={classes.img}
                        />
                      )}
                    </div>

                    <div className={classes.infoWrapper}>
                      <div className={classes.infoButtonsWrapper}>
                        <div className={classes.containerLink}>
                          <Link
                            to={`${`/viewproduct/${order.product.id}`}`}
                            className={classes.link}
                          >
                            {order.product.name}
                          </Link>
                        </div>

                        <div className={classes.containerSum}>
                          <Typography className={classes.productPrice}>
                            {thousands(String(getPriceProduct(order)))} руб.
                          </Typography>
                          <Typography className={classes.titlePriceOnce}>
                            Цена за 1 шт.
                          </Typography>
                        </div>

                        <div className={classes.containerCount}>
                          <Typography className={classes.count}>{order.count}</Typography>
                        </div>

                        <div className={classes.containerSum}>
                          <Typography className={classes.sum}>
                            {thousands(String(getPriceProduct(order) * order.count))} руб.
                          </Typography>

                          <Typography className={classes.titleSum}>Сумма</Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}

        {isVendor && (
          <Card className={classes.card}>
            <CardContent className={classes.containerSumVendor}>
              <div className={classes.wrapperSumVendor}>
                <Typography className={classes.titleVendorSum}>ИТОГО ПО ПРОДАВЦУ:</Typography>

                <Typography className={classes.vendorSum}>
                  {thousands(String(isVendor ? orders?.vendor_summ || 0 : orders?.summ || 0))}{' '}
                  руб.
                </Typography>
              </div>

              <div>
                {selectedId !== orders?.id ? (
                  <Typography className={classes.paymentStatus}>
                    <p>{translates[orders?.payment_status || '']}</p>
                  </Typography>
                ) : (
                  <TextField
                    select
                    margin='none'
                    value={orders?.payment_status}
                    onChange={event => {
                      editStatus &&
                        editStatus({
                          id: orders.id,
                          page: 1,
                          perPage: 20,
                          data: {
                            payment_status: event.target.value,
                            items: orders.items.map(e => ({
                              count: e.count,
                              product_id: e.product.id,
                            })),
                          },
                          userId: me?.id,
                          root: me?.is_admin,
                        });
                      selectAction(-1);
                    }}
                    variant='outlined'
                    className={classes.typeList}
                    size='small'
                  >
                    {orderTypeList &&
                      orderTypeList.map(option => (
                        <MenuItem key={option.type} value={option.type}>
                          {translates[option.type]}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
              </div>

              <ButtonWithLoader
                onPress={() =>
                  orders
                    ? openPayment(isVendor || me?.is_admin ? 'seller' : 'buyer', orders)
                    : {}
                }
              >
                Реквизиты для оплаты
              </ButtonWithLoader>
            </CardContent>
          </Card>
        )}
        {(isBuyer || me?.is_admin) && (
          <Card className={classes.card}>
            <CardContent className={classes.containerSumVendor}>
              <div className={classes.wrapperSumVendor}>
                <Typography className={classes.titleVendorSum}>ИТОГО:</Typography>

                <Typography className={classes.vendorSum}>
                  {thousands(String(isVendor ? orders?.vendor_summ || 0 : orders?.summ || 0))}{' '}
                  руб.
                </Typography>
              </div>

              <div>
                {selectedId !== orders?.id ? (
                  <Typography className={classes.paymentStatus}>
                    <p>{translates[orders?.payment_status || '']}</p>
                  </Typography>
                ) : (
                  <TextField
                    select
                    margin='none'
                    value={orders?.payment_status}
                    onChange={event => {
                      editStatus &&
                        editStatus({
                          id: orders.id,
                          page: 1,
                          perPage: 20,
                          data: {
                            payment_status: event.target.value,
                            items: orders.items.map(e => ({
                              count: e.count,
                              product_id: e.product.id,
                            })),
                          },
                          userId: me?.id,
                          root: me?.is_admin,
                        });
                      selectAction(-1);
                    }}
                    variant='outlined'
                    className={classes.typeList}
                    size='small'
                  >
                    {orderTypeList &&
                      orderTypeList.map(option => (
                        <MenuItem key={option.type} value={option.type}>
                          {translates[option.type]}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
              </div>

              <ButtonWithLoader
                onPress={() =>
                  orders ? openPayment(isVendor ? 'seller' : 'buyer', orders) : {}
                }
              >
                Реквизиты для оплаты
              </ButtonWithLoader>
            </CardContent>
          </Card>
        )}
        <AlertCompanyDetail
          open={isOpenCompanyDialog}
          message={intl.formatMessage({ id: 'FILE.IMPORT.ALERT.TEXT' })}
          company={com}
          handleClose={() => {
            setOpenCompanyDialog(false);
          }}
        />

        <Payment
          open={showPayment}
          handleClose={() => {
            setShowPayment(false);
            setPaymentInfo({} as any);
          }}
          order={paymentInfo.order}
          type={paymentInfo.type}
        />

        <AlertCompanyDetail
          open={isOpenEstimateDialog}
          message={intl.formatMessage({ id: 'FILE.IMPORT.ALERT.TEXT' })}
          // company={est}
          handleClose={() => {
            setOpenEstimateDialog(false);
          }}
        />
      </>
    </>
  );
};

export default OrderTable;
